import { ReactNode } from 'react';
import { useFormikContext } from 'formik';
import { MenuItem, TextField } from '@mui/material';
import { get } from 'lodash';
import OrganizationSetting from './Setting';
import { OrganizationSettings } from '@/types';

interface Props {
  field: string;
  title: string;
  description: string;
  options: Array<{
    label: string;
    value: string;
    children?: ReactNode;
  }>;
}

const SelectSetting = ({ field, title, description, options }: Props) => {
  const { values, setFieldValue } = useFormikContext<OrganizationSettings>();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(field, event.target.value);
  };

  return (
    <OrganizationSetting title={title} description={description}>
      <TextField
        value={get(values, field, '')}
        select
        fullWidth
        variant="outlined"
        onChange={handleChange}
        sx={{
          width: 300
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                paddingRight: '8px',
              }}
            >
              {option.label}
              {option.children}
            </span>
          </MenuItem>
        ))}
      </TextField>
    </OrganizationSetting>
  );
};

export default SelectSetting;
